import { render, staticRenderFns } from "./saveOrUpdateSysStudent.vue?vue&type=template&id=544c8199&scoped=true&"
import script from "./saveOrUpdateSysStudent.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdateSysStudent.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdateSysStudent.vue?vue&type=style&index=0&id=544c8199&scoped=true&lang=scss&"
import style1 from "./saveOrUpdateSysStudent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c8199",
  null
  
)

export default component.exports